import React, { useEffect } from "react";
import { Calendar, Clock, Search } from "lucide-react";

export default function Filters({
    filters,
    setFilters,
    pageSize,
    setPageSize,
    onSubmit,
    loading,
}) {
    const MAX_MINUTES = 30;

    // 🟦 Tự động set startTime = now, endTime = now + 1'
    useEffect(() => {
        if (!filters.startTime && !filters.endTime) {
            const now = new Date();
            const start = now.toISOString().slice(11, 16);

            const after1m = new Date(now.getTime() + 1 * 60000);
            const end = after1m.toISOString().slice(11, 16);

            setFilters((prev) => ({
                ...prev,
                startTime: start,
                endTime: end,
            }));
        }
    }, []);

    // 🟥 Hàm validate khoảng thời gian
    const validateRange = (start, end) => {
        if (!start || !end) return true;

        const startDate = new Date(`1970-01-01T${start}:00Z`);
        const endDate = new Date(`1970-01-01T${end}:00Z`);

        const diff = (endDate - startDate) / 60000; // phút

        return diff <= MAX_MINUTES;
    };

    const handleSubmit = () => {
        if (!validateRange(filters.startTime, filters.endTime)) {
            alert("Khoảng thời gian không được vượt quá 30 phút!");
            return;
        }
        onSubmit();
    };

    // Khi người dùng thay đổi endTime → auto chặn > 30 phút
    const handleTimeChange = (field, value) => {
        const newFilters = { ...filters, [field]: value };

        if (!validateRange(newFilters.startTime, newFilters.endTime)) {
            alert("Thời gian không được vượt quá 30 phút!");
            return;
        }

        setFilters(newFilters);
    };

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
            }}
            className="bg-white border border-gray-200 rounded-2xl p-4 mb-6 shadow-sm"
        >
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {/* Ngày */}
                <div>
                    <label className="text-xs font-medium text-gray-700 mb-1 flex gap-2">
                        <Calendar size={14} /> Ngày *
                    </label>
                    <input
                        type="date"
                        value={filters.day}
                        onChange={(e) =>
                            setFilters({ ...filters, day: e.target.value })
                        }
                        className="w-full bg-gray-50 border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    />
                </div>

                {/* Từ giờ */}
                <div>
                    <label className="text-xs font-medium text-gray-700 mb-1 flex gap-2">
                        <Clock size={14} /> Từ giờ *
                    </label>
                    <input
                        type="time"
                        value={filters.startTime}
                        onChange={(e) =>
                            handleTimeChange("startTime", e.target.value)
                        }
                        className="w-full bg-gray-50 border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    />
                </div>

                {/* Đến giờ */}
                <div>
                    <label className="text-xs font-medium text-gray-700 mb-1 flex gap-2">
                        <Clock size={14} /> Đến giờ *
                    </label>
                    <input
                        type="time"
                        value={filters.endTime}
                        onChange={(e) =>
                            handleTimeChange("endTime", e.target.value)
                        }
                        className="w-full bg-gray-50 border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    />
                </div>

                {/* Message ID */}
                <div>
                    <label className="text-xs font-medium text-gray-700 mb-1 flex gap-2">
                        <Search size={14} /> Message ID (optional)
                    </label>
                    <input
                        type="text"
                        placeholder="Nhập ID nếu có"
                        value={filters.clientMsgId}
                        onChange={(e) =>
                            setFilters({
                                ...filters,
                                clientMsgId: e.target.value,
                            })
                        }
                        className="w-full bg-gray-50 border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    />
                </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between mt-4">
                <div className="flex items-center gap-2 text-sm text-gray-700">
                    <span>Hiển thị</span>
                    <select
                        value={pageSize}
                        onChange={(e) => setPageSize(Number(e.target.value))}
                        className="bg-gray-50 border border-gray-300 rounded-lg px-2 py-1 text-gray-900"
                    >
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                    <span>bản ghi / trang</span>
                </div>

                <button
                    type="submit"
                    className="bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded-lg text-sm flex gap-2 items-center font-semibold transition-colors disabled:opacity-50"
                    disabled={loading}
                >
                    <Search size={16} />
                    Tìm kiếm
                </button>
            </div>
        </form>
    );
}
